import { Routes, UrlSegment } from '@angular/router';
import { ApplicationGuard } from './modules/usermgmt/guards/application.guard';

// import { AuthGuard } from 'usermgmt';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'landing',
    pathMatch: 'full',
  },
  {
    path: 'landing',
    canActivate: [ApplicationGuard],
    data: { hideSidebar: true },
    loadComponent: () =>
      import('./pages/landing-page/landing-page.component').then(
        (mod) => mod.LandingPageComponent
      ),
  },
  {
    path: 'portal',
    // canActivate : [ApplicationGuard],
    // data: { hideSidebar: true },
    data: { hideSidebar: true },
    loadComponent: () =>
      import('./pages/public-portal/public-portal.component').then(
        (mod) => mod.PublicPortalComponent
      ),
  },
  {
    path: 'lps',
    // canActivate : [ApplicationGuard],
    // data: { hideSidebar: true },
    data: { hideSidebar: true },
    loadComponent: () =>
      import('./pages/lps-page/lps-page-dashboard/lps-page-dashboard.component').then((mod) => mod.LpsPageDashboardComponent),
  },
  {
    path: 'home',
    canActivate: [ApplicationGuard],
    data: { resource: 'Geo-Portal' },
    loadComponent: () =>
      import('./pages/crda-geo-land-monetization-allotment/crda-geo-land-dashboard/crda-geo-land-dashboard.component').then((mod) => mod.CrdaGeoLandDashboardComponent),

  },
  {
    path: 'amruth',
    // canActivate : [ApplicationGuard],
    // data: {resource: 'Amruth Module'},
    loadComponent: () =>
      import('./pages/Amruthlayers/Amruth-dashboard/Amruth-dashboard.component').then(
        (mod) => mod.DashboardComponent
      ),
  },
  {
    path: 'works',
    canActivate: [ApplicationGuard],
    data: { resource: 'Works Module' },
    loadComponent: () =>
      import('./pages/works-module/works-dashboard/works-dashboard.component').then(
        (mod) => mod.WorksDashboardComponent
      )
  },
  {
    path: 'housing',
    canActivate: [ApplicationGuard],
    data: { resource: 'Housing Module' },
    loadComponent: () =>
      import('./pages/works-module/works-dashboard/works-dashboard.component').then(
        (mod) => mod.WorksDashboardComponent
      )
  },
  {
    path: 'works-map-view',
    data: { hideSidebar: true },
    loadComponent: () =>
      import('./pages/works-module/works-map-view/works-map-view.component').then(
        (mod) => mod.WorksMapViewComponent
      )
  },
  {
    matcher: (segments: UrlSegment[]) => {
      // Original logic for /works-map-view/ID/TOKEN
      if (segments.length >= 3 && segments[0].path === 'works-map-view') {
        const accesstoken = segments[segments.length - 1];
        const idSegments = segments.slice(1, segments.length - 1);
        const idValue = idSegments.map(s => s.path).join('/');
        
        return {
          consumed: segments,
          posParams: {
            id: new UrlSegment(idValue, {}),
            accesstoken: accesstoken
          }
        };
      }
      
      // New logic for direct /ID/TOKEN (e.g. /WIN/0010/24-25/gAAAA...)
      // Matches if there are at least 2 segments and the last segment is a long token
      if (segments.length >= 2) {
        const lastSegment = segments[segments.length - 1].path;
        if (lastSegment.length > 50 || lastSegment.startsWith('gAAAA')) {
          const accesstoken = segments[segments.length - 1];
          const idSegments = segments.slice(0, segments.length - 1);
          const idValue = idSegments.map(s => s.path).join('/');
          
          return {
            consumed: segments,
            posParams: {
              id: new UrlSegment(idValue, {}),
              accesstoken: accesstoken
            }
          };
        }
      }
      
      return null;
    },
    data: { hideSidebar: true },
    loadComponent: () =>
      import('./pages/works-module/works-map-view/works-map-view.component').then(
        (mod) => mod.WorksMapViewComponent
      )
  },
  {
    path: 'unauthorized-cultivation',
    canActivate: [ApplicationGuard],
    data: { resource: 'Unauthorized Cultivation' },
    loadComponent: () =>
      import('./pages/crda-unauthorised-cultivation/crda-unauthorised-cultivation-dashboard/crda-unauthorised-cultivation-dashboard.component').then((mod) => mod.CrdaUnauthorisedCultivationDashboardComponent),
  },
  {
    path: 'metadata-management',
    canActivate: [ApplicationGuard],
    data: { resource: 'Metadata Management' },
    loadComponent: () =>
      import('./pages/metamanagement/metamanagementdashboard/metamanagementdashboard.component').then(
        (mod) => mod.MetamanagementdashboardComponent
      ),
  },
  {
    path: 'unauthorized-construction',
    canActivate: [ApplicationGuard],
    data: { resource: 'Unauthorized Construction' },
    loadComponent: () =>
      import('./pages/construction/construction-dashboard/construction-dashboard.component').then((mod) => mod.ConstructionDashboardComponent),
  },
  {
    path: 'green-cover-monitoring',
    canActivate: [ApplicationGuard],
    data: { resource: 'Green Cover Monitoring' },
    loadComponent: () =>
      import('./pages/Greencover/green-cover-dashboard/green-cover-dashboard.component').then((mod) => mod.GreenCoverDashboardComponent),
  },
  {
    path: 'road-network-monitoring',
    canActivate: [ApplicationGuard],
    data: { resource: 'Road Condition Monitoring' },
    loadComponent: () =>
      import('./pages/RoadCondition/road-condition-dashboard/road-condition-dashboard.component').then((mod) => mod.RoadConditionDashboardComponent),
  },
  {
    path: 'new-geoportal',
    canActivate: [ApplicationGuard],
    data: { resource: 'Theme City' },
    loadComponent: () =>
      import('./pages/new-geoportal/new-geoportal-dashboard/new-geoportal-dashboard.component').then((mod) => mod.NewGeoportalDashboardComponent),
  },
  {
    path: 'land-acquisitions',
    canActivate: [ApplicationGuard],
    data: { resource: 'Land Acquisitions' },
    loadComponent: () =>
      import('./pages/Land-Under-LA/land-under-la-dashboard/land-under-la-dashboard.component').then((mod) => mod.LandUnderLaDashboardComponent),
  },
  {
    path: 'infra-zone',
    canActivate: [ApplicationGuard],
    data: { resource: 'Infra Zone' },
    loadComponent: () =>
      import('./pages/InfraZone/infra-zone-dashboard/infra-zone-dashboard.component').then((mod) => mod.InfraZoneDashboardComponent),
  }, {
    path: 'lps-village',
    canActivate: [ApplicationGuard],
    data: { resource: 'LPS Village View' },
    loadComponent: () =>
      import('./pages/lpsModule/lps-module-dashboard/lps-module-dashboard.component').then((mod) => mod.LpsModuleDashboardComponent),
  },
  {
    path: 'sector-zone',
    canActivate: [ApplicationGuard],
    data: { resource: 'Sector Zone' },
    loadComponent: () =>
      import('./pages/SectorZone/sector-zone-dashboard/sector-zone-dashboard.component').then(
        (mod) => mod.SectorZoneDashboardComponent
      ),
  },
  {
    path: 'layout',
    canActivate: [ApplicationGuard],
    data: { resource: 'Layout Dashboard' },
    loadComponent: () =>
      import('./pages/Layout/layout-dashboard/layout-dashboard.component').then((mod) => mod.LayoutDashboardComponent),
  },
  {
    path: 'financial',
    canActivate: [ApplicationGuard],
    data: { resource: 'Financial Overview' },
    loadComponent: () =>
      import('./pages/Financial/Financial-dashboard/Financial-dashboard.component').then((mod) => mod.FinancialDashboardComponent),
  },
  {
    path: 'shelter-management',
    canActivate: [ApplicationGuard],
    data: { resource: 'Shelter Management' },
    loadComponent: () =>
      import('./pages/disaster-management/shleter-dashboard/shelter-dashboard.component').then(
        (mod) => mod.ShelterDashboardComponent
      ),
  }, {
    path: 'winds',
    canActivate: [ApplicationGuard],
    data: { resource: 'Wind' },
    loadComponent: () =>
      import('./pages/disaster-management/winds/winds-dashboard/winds-dashboard.component').then(
        (mod) => mod.WindsDashboardComponent
      ),
  },
  {
    path: 'rainfall',
    canActivate: [ApplicationGuard],
    data: { resource: 'Rainfall' },
    loadComponent: () =>
      import('./pages/disaster-management/rainfall/rainfall-dashboard/rainfall-dashboard.component').then(
        (mod) => mod.RainfallDashboardComponent
      ),
  },
  {
    path: 'lightning',
    canActivate: [ApplicationGuard],
    data: { resource: 'Lightning' },
    loadComponent: () =>
      import('./pages/disaster-management/lightning/lightning-dashboard/lightning-dashboard.component').then(
        (mod) => mod.LightningDashboardComponent
      ),
  },
  {
    path: 'flooding',
    canActivate: [ApplicationGuard],
    data: { resource: 'Flooding' },
    loadComponent: () =>
      import('./pages/disaster-management/flooding/flooding-dashboard/flooding-dashboard.component').then(
        (mod) => mod.FloodingDashboardComponent
      ),
  },
  {
    path: 'cyclone',
    canActivate: [ApplicationGuard],
    data: { resource: 'Cyclone' },
    loadComponent: () =>
      import('./pages/disaster-management/cyclone/cyclone-dashboard/cyclone-dashboard.component').then(
        (mod) => mod.CycloneDashboardComponent
      ),
  },
  {
    path: 'heatmap',
    canActivate: [ApplicationGuard],
    data: { resource: 'Heatwave Advisory' },
    loadComponent: () =>
      import('./pages/disaster-management/heatmap/heatmap-dashboard/heatmap-dashboard.component').then(
        (mod) => mod.HeatmapDashboardComponent
      ),
  },
  {
    path: 'land',
    canActivate: [ApplicationGuard],
    data: { resource: 'LPS Summary' },
    loadComponent: () =>
      import('./pages/Land/land-dashboard/land-dashboard.component').then(
        (mod) => mod.LandDashboardComponent
      ),
  },
  {
    path: 'access-denied',
    loadComponent: () =>
      import('./pages/no-application-access/no-application-access.component').then(
        (mod) => mod.NoApplicationAccessComponent
      ),
  },
  {
    path: 'usermgmt',
    canActivate: [ApplicationGuard],
    data: { resource: 'User Management' },
    loadChildren: () =>
      import('usermgmt').then((m) => m.userMgmtRoutes)
  },
  {
    path: 'estate-management',
    canActivate: [ApplicationGuard],
    data: { resource: 'Estate Management' },
    loadComponent: () =>
      import('./pages/estate-management/estate-management-dashboard/estate-managemnet-dashboard.component').then((mod) => mod.EstateManagementDashboardComponent),
  },
  {
    path: 'land-acquisition-nsp-overview',
    canActivate: [ApplicationGuard],
    data: { resource: 'Land Acquisition And NSP' },
    loadComponent: () =>
      import('./pages/LA-NSP/LANSP-dashboard/LANSP-dashboard.component').then(
        (mod) => mod.DashboardComponent
      ),
  },
  {
    path: 'deployment-progress',
    data: { hideSidebar: true },
    loadComponent: () =>
      import('./shared/components/deploynment-progress/deploynment-progress.component').then(
        (mod) => mod.DeploynmentProgressComponent
      ),
  },
  {
    path: 'data-insertion',
    canActivate: [ApplicationGuard],
    data: { resource: 'Data Insertion' },
    loadComponent: () =>
      import('./pages/metamanagement/data-insertion/data-insertion.component').then(
        (mod) => mod.DataInsertionComponent
      ),
  },
  {
    path: 'dynamic-views',
    loadComponent: () =>
      import('./pages/dynamic-view-creation/dynamic-views.component').then(
        (mod) => mod.DynamicViewsComponent
      ),
  },
  {
    path: 'dynamic-view-creation',
    loadComponent: () =>
      import('./pages/dynamic-view-creation/dynamic-view-creation.component').then(
        (mod) => mod.DynamicViewCreationComponent
      ),
  },
  {
    path: '**',
    redirectTo: 'landing',
  },
];
